module.exports = {"name":"dna-linkblock-newsroom-podcast"}


//////////////////
// WEBPACK FOOTER
// ./src/content/project.json
// module id = peJn
// module chunks = 1